import { TFunction } from "i18next";

import { AppointmentLabels } from "@/common/hooks/useAppointmentLabels";

export const ExchangeColumnWidth = {
  date: 150,
  time: 110,
  location: 170,
  createdAt: 130,
  counselorUserCode: 90,
  purposeKey: 140,
  // Wide enough for the "Angebote" header plus its sort arrow on one line.
  offersCount: 150,
  // A floor, not a cap: the labelled action button ("Angebot zurückziehen") keeps its room.
  action: 220,
};

/** The requested Dienste as one phrase, e.g. "BG oder AW3". */
export function joinRequestedPurposeLabels(purposeKeys: string[], labels: AppointmentLabels, t: TFunction): string {
  const names = purposeKeys.map((key) => labels.purposeLabelOf(key));
  return names.join(` ${t("exchange.requested.or")} `);
}

/** "Gesucht" column text, e.g. "gegen BG oder AW3". */
export function formatRequestedPurposes(purposeKeys: string[], labels: AppointmentLabels, t: TFunction): string {
  return `${t("exchange.requested.prefix")} ${joinRequestedPurposeLabels(purposeKeys, labels, t)}`;
}
